/**
 * チケット詳細を別タブで開く。
 * 関連チケットからの遷移・各画面からのパラメータ指定での詳細表示は
 * 全て別タブ（新しいタブ）で開く方針（ticket_1.md）。
 * 別タブで開いた詳細の「閉じる」は履歴を戻すのではなくタブ自体を閉じる（closeTicketTab）。
 */
export const openTicketInNewTab = (ticketId: string) => {
  window.open(`/ticket/${ticketId}`, '_blank', 'noopener,noreferrer');
};

/** 別タブで開いた詳細（direct-link）を閉じる。 */
export const closeTicketTab = () => {
  window.close();
};
